import { render, staticRenderFns } from "./GlobalLeader.vue?vue&type=template&id=3ab31d1d&scoped=true"
import script from "./GlobalLeader.js?vue&type=script&lang=js&external"
export * from "./GlobalLeader.js?vue&type=script&lang=js&external"
import style0 from "./GlobalLeader.scss?vue&type=style&index=0&id=3ab31d1d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab31d1d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Title/Title.vue').default,HotContainer: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Container/Container.vue').default,HotCarousel: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/Carousel/Carousel.vue').default,HotCounter: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/Counter/Counter.vue').default,HotButtonJobs: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/ButtonJobs/ButtonJobs.vue').default})
